<script>
import BasePopup from '@/components/BasePopup.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';
import FormBlock from '@/components/FormBlock.vue';
import form from '@/utils/form';
import BaseField from '@/components/BaseField.vue';

export default {
  name: 'SupplierManualDirForm',
  controller: null,
  components: {
    FormBlock,
    AvatarEditable,
    BasePopup,
    BaseField,
  },
  data() {
    return {
      isOpened: false,
      avatar: null,
      companyFields: {
        name: form.createFieldObject('string', 'Название компании', ''),
        website: form.createFieldObject('string', 'Сайт', ''),
        phone: form.createFieldObject('string', 'Телефон', ''),
        address: form.createFieldObject('string', 'Адрес', ''),
        region: form.createFieldObject('string', 'Регион', ''),
      },
      managerFields: {
        managerName: form.createFieldObject('string', 'Имя менеджера', ''),
        managerPhone: form.createFieldObject('string', 'Телефон менеджера', ''),
        managerEmail: form.createFieldObject('string', 'E-mail менеджера', ''),
      },
    };
  },
  methods: {
    save() {
      this.isOpened = false;
      const data = {
        ...form.getValues(this.companyFields),
        ...form.getValues(this.managerFields),
        avatar: this.avatar?.['@id'] ?? null,
      };
      this.$options.controller.resolve(data);
      form.clear(this.companyFields);
      form.clear(this.managerFields);
    },

    open(data) {
      if (data) {
        this.avatar = data.avatar;
        form.setValues(this.companyFields, data);
        form.setValues(this.managerFields, data);
      }

      this.isOpened = true;

      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close() {
      this.isOpened = false;
      form.clear(this.companyFields);
      form.clear(this.managerFields);
      this.$options.controller.resolve();
    },
  },
};
</script>

<template lang="pug">
BasePopup.popup(v-if="isOpened" @close="close")
  .supplier-manual-dir-form
    .title Поставщик
    //AvatarEditable(v-model="avatar" placeholder="no-avatar-project")
    AvatarEditable(:avatar="avatar" @change="avatar = $event" placeholder="no-avatar-project")
    FormBlock.form
      BaseField._name(
        v-for="(field, name) in companyFields"
        v-model="field.value"
        v-bind="field"
        :key="name"
        labelOuter
      )
    FormBlock.form
      BaseField._name(
        v-for="(field, name) in managerFields"
        v-model="field.value"
        v-bind="field"
        :key="name"
        labelOuter
      )
    .buttons
      Btn(grey @click="close") Отмена
      Btn(green @click="save") Сохранить

</template>

<style scoped lang="scss">
  ::v-deep .wrap {
    background: #F8F9FC;
  }

  .supplier-manual-dir-form {
    display: grid;
    grid-template-columns: 184px 400px 400px;
    gap: 40px;
    align-items: start;
    padding: 40px 40px 20px;
  }

  .title {
    grid-column: 1 / 3 span;
    font-size: 36px;
    font-weight: 700;
    line-height: 24px;
    letter-spacing: 0.02em;
  }

  .buttons {
    grid-column: 1 / 3 span;
    display: flex;
    justify-content: flex-end;
    gap: 20px;
  }

  .form {
    display: grid;
    gap: 15px;
  }
</style>
